import { addMinutes, endOfDay, startOfDay } from 'date-fns';
import { useCallback } from 'react';
import { type DatePickerDateType, getDateType } from 'ui';
import { useGetStartDateTime } from './useGetStartDateTime';

type ReminderDateTimeFormValues = {
  isAllDay: boolean;
  startDate: DatePickerDateType;
  startTime: string;
};

export const useGetReminderDateTime = () => {
  const getStartDateTime = useGetStartDateTime();

  return useCallback(
    ({ isAllDay, startDate, startTime }: ReminderDateTimeFormValues) => {
      const reminderStartTime = isAllDay
        ? startOfDay(getDateType(startDate))
        : getStartDateTime({ startDate, startTime });
      const reminderEndTime = isAllDay ? endOfDay(getDateType(startDate)) : addMinutes(reminderStartTime, 15);

      return { endTime: reminderEndTime, startTime: reminderStartTime };
    },
    [getStartDateTime],
  );
};
